
export enum TransactionEventDetailTypeCd {
	DELETE = 'Delete',
	INSERT = 'Insert',
	UPDATE = 'Update'}

